/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * 手机正则
 * @returns {string}
 */
export const isPhone = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;

// 验证
export const FormValidators = {
  /* 手机号码 */
  mobilePhone(rule, value, callback) {
    // validateFn('mobilePhone', rule, value, callback, '[' + rule.label + ']手机号码格式有误')
    validateFn('mobilePhone', rule, value, callback, '手机号码格式有误');
  },
  // 身份证号
  idCardDif(rule, value, callback) {
    validateFn('idCardDif', rule, value, callback, '身份证号格式有误');
  },
  // 手机+座机
  allPhone(rule, value, callback) {
    validateFn('allPhone', rule, value, callback, '电话号码格式有误');
  },
  // 统一社会信用代码
  creditCode(rule, value, callback) {
    validateFn('creditCode', rule, value, callback, '统一社会信用代码格式有误');
  },
  // 数字和 .
  numberOrPoint(rule, value, callback) {
    validateFn('numberOrPoint', rule, value, callback, '数据格式有误');
  },
  // 数字
  number(rule, value, callback) {
    validateFn('number', rule, value, callback, '数据格式有误');
  },
  // 整数
  int(rule, value, callback) {
    validateFn('int', rule, value, callback, '数据格式有误');
  },
  // 正整数
  positiveInt(rule, value, callback) {
    validateFn('positiveInt', rule, value, callback, '数据格式有误');
  },
  // 所有车牌
  allCar(rule, value, callback) {
    validateFn('allCar', rule, value, callback, '数据格式有误');
  },
  positiveInteger(rule, value, callback) {
    validateFn('positiveInteger', rule, value, callback, '请输入大于0的数字');
  },
  notChinese(rule, value, callback) {
    validateFn('noChinese', rule, value, callback, '不允许输入正文');
  },
  negativeOrPositiveInt(rule, value, callback) {
    validateFn(
      'negativeOrPositiveInt',
      rule,
      value,
      callback,
      '不允许输入正文'
    );
  },
};

const validateFn = function(
  validatorName,
  rule,
  value,
  callback,
  defaultErrorMsg
) {
  // 空值不校验
  if (isNull(value) || value.length <= 0) {
    callback();
    return;
  }
  // eslint-disable-next-line no-eval
  const reg = eval(getRegExp(validatorName));
  if (!reg.test(value)) {
    const errTxt = rule.errorMsg || defaultErrorMsg;
    callback(new Error(errTxt));
  } else {
    callback();
  }
};
function isNull(value) {
  return value === null || value === undefined;
}
const getRegExp = function(validatorName) {
  const commonRegExp = {
    negativeOrPositiveInt: '/^-?[1-9]+[0-9]*$|^0$/',
    number: '/^\\d+(\\.\\d+)?$/',
    int: '/^[0-9]+$/',
    positiveInt: '/^([0]|[1-9][0-9]*)$/',
    positiveInteger: /^[1-9]\d*$/,
    letter: '/^[A-Za-z]$/',
    letterAndNumber: '/^[A-Za-z0-9]+$/',
    // 大写字母和数字
    upperLetterAndNumber: '/^[A-Z0-9]+$/',
    mobilePhone: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
    // 所有联系方式：手机号+座机号
    allPhone: '/^(((\\d{3,4}-)?\\d{7,8}(-\\d{1,8})?)|(\\d{7,8})|(1\\d{10}))$/',
    telPhone: '/^([0-9]{3,4}-)?[0-9]{7,8}$/',
    letterStartNumberIncluded: '/^[A-Za-z]+[A-Za-z\\d]*$/',
    noChinese: '/^[^\u4e00-\u9fa5]+$/',
    noNumber: /\D/,
    chinese: '/^[\u4e00-\u9fa5]+$/',
    chineseAndLetter: '/^[\u4e00-\u9fa5a-zA-Z]+$/',
    chineseAndLetterAndNumber: '/^[\u4e00-\u9fa5a-zA-Z0-9]+$/',
    email: '/^([-_A-Za-z0-9.]+)@([_A-Za-z0-9]+\\.)+[A-Za-z0-9]{2,3}$/',
    // 邮编
    zipCode: '/^\\d{6}$/',
    url:
      '/^([hH][tT]{2}[pP]:\\/\\/|[hH][tT]{2}[pP][sS]:\\/\\/)(([A-Za-z0-9-~]+)\\.)+([A-Za-z0-9-~\\/])+$/',
    // 身份证号
    idCardDif:
      '/^([1-6][1-9]|50)\\d{4}(18|19|20)\\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$/', // 复杂版本
    creditCode: '/^[A-Z0-9]{18}$/',
    numberOrPoint: '/^[0-9.]+$/',
    allCar:
      '/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/',
  };

  return commonRegExp[validatorName];
};
